import React from "react";
import { Drawer, Typography, Box, IconButton } from "@mui/material";
import UnreadToggle from "./UnreadToggle";
import ButtonToIndex from "./ButtonToIndex";

export default function UnreadModalMobile({
  open,
  onClose,
  activeType,
  projectIndexUrl,
  jobIndexUrl,
  unreadProjects,
  unreadJobs,
  onChangeActiveType,
  projectUnreadCount,
  jobUnreadCount,
}) {
  const items = activeType === "projects" ? unreadProjects : unreadJobs;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          height: "100vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", px: 2, pt: 3, pb: 3 }}>
        <IconButton
          onClick={onClose}
          sx={{ fontSize: "16px", position: "absolute", top: 5, right: 20 }}
        >
          閉じる
        </IconButton>
        <Box sx={{ pt: 3 }}>
          <UnreadToggle
            value={activeType}
            onChange={onChangeActiveType}
            projectUnreadCount={projectUnreadCount}
            jobUnreadCount={jobUnreadCount}
          />
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          px: 3,
          pt: 1.5,
          bgcolor: "#fff",
          maxHeight: "75vh",
        }}
      >
        {items.length === 0 ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: "center", py: 6 }}
          >
            {activeType === "projects"
              ? "未読のプロジェクトはありません"
              : "未読の求人はありません"}
          </Typography>
        ) : (
          <Box sx={{ maxWidth: 764, width: "100%", mx: "auto" }}>
            {items.map((it) => {
              const href =
                activeType === "projects" ? `/projects/${it.id}` : `/jobs/${it.id}`;
              return (
                <Box
                  key={it.id}
                  component="a"
                  href={href}
                  onClick={onClose}
                  sx={{
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                    bgcolor: "#F6F6F7",
                    borderRadius: 1.5,
                    pt: "29px",
                    pb: "8px",
                    px: "12px",
                    mb: 2,
                    "&:hover": { bgcolor: "#eee" },
                  }}
                >
                  <Typography sx={{ fontSize: "14px", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                    {it.title}
                  </Typography>
                  {it.price && (
                    <Typography sx={{ fontSize: "14px", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                      {it.price}
                    </Typography>
                  )}
                  <Typography sx={{ fontSize: 12, textAlign: "right", mt: 1 }}>
                    {it.date}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
      <Box sx={{ my: "15px", mx: "30px", fontSize: "16px" }}>
        <ButtonToIndex
          activeType={activeType}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
        />
      </Box>
    </Drawer>
  );
}
